
import { environment } from '../environments/environment';
export const API_ENDPOINT = environment.API_URL;